import useSWR from 'swr';
import { PolicyExtended } from 'utility/node/policy/policy.model';
import { getPolicyByIdRoute } from 'utility/node/routes';

export const usePolicyById = (policyId: number, fetch = true) => {
  const policySwrKey = getPolicyByIdRoute(policyId);

  const { data, error, mutate } = useSWR<PolicyExtended>(
    fetch ? policySwrKey : null,
  );

  return {
    policy: data,
    policyErrors: error,
    mutatePolicy: mutate,
    policyLoading: !data && !error && fetch,
  };
};
